import request from '@/utils/request'

const basePath = "/api/enterprise/jobPositionApplyRecord";


/**
 * 获取个人职位申请记录
 * @param params {jobPositionName: '', enterpriseName: '', status: 0}
 */
export function getApplyRecordPageList(params) {
    return request({
        url: `${basePath}/`,
        method: 'get',
        params: params
    })
}
